module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedLightItalic.50db687.woff";